import { Avatar, Button, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { LeftArrowWhite } from 'Images';

interface ISend {
  onClickSend: () => void;
}

export const Send = ({ onClickSend }: ISend) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Feedback);

  return (
    <Button
      variant='primary'
      sx={{
        p: '12px 89px',
        borderRadius: '22px',
        maxWidth: '244px',
        m: '8px auto 0px',
      }}
      onClick={onClickSend}
    >
      <Typography variant='body4' component='span'>
        {dictionary.send}
      </Typography>
      <Avatar
        alt=''
        src={LeftArrowWhite}
        sx={{ width: '20px', height: '20px' }}
      />
    </Button>
  );
};
